import { Component, OnInit } from '@angular/core';
import { NotificationEnce } from '../../interfaces/NotificationEnce.interface';

@Component({
  selector: 'app-offer',
  templateUrl: './offer.component.html',
  styleUrls: ['./offer.component.css']
})
export class OfferComponent implements OnInit {

  public offerList: Array<NotificationEnce>;
  public numNotification: number;

  constructor() { 
    
  }

  ngOnInit() {


    let intervalNoti = setInterval(()=>{
      if(localStorage.getItem('notifications')){
        this.offerList=JSON.parse(localStorage.getItem('notifications'));
        this.numNotification=this.offerList.length;
        localStorage.removeItem('notifications');
        clearInterval(intervalNoti);
      }
    },500);
    
  }

  public formatDate(date:string):string{
    let dateArray:Array<string> = [];
    let dateFormat:string;
    let aux:string;
    let auxArray:Array<string>;
    dateArray = date.split('-');
    aux = dateArray[2].toString();
    auxArray = aux.split(' ');
    dateFormat= auxArray[0]+'/'+dateArray[1]+'/'+dateArray[0];
    return dateFormat;
  }


  public initNotifications(){
    let obj = {
      "title":'',
      "description":'',
      "start_date":''
    }
    this.offerList.push(obj);
  }
}
